import { Header } from "@gravity/tools";
import { useUserState } from "@gx1/gx-npm-lib";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { navigateToUrl } from "single-spa";
import { MainNavAppV2Context } from "../../app-v2.context";
import styles from "./global-header.styles.module.scss";

const GlobalHeaderComponent = () => {
  const { t } = useTranslation();

  const {
    isMobilePrimaryNavOpen,
    notificationCount,
    setIsMobilePrimaryNavOpen,
    setIsNotificationsPanelOpen,
  } = useContext(MainNavAppV2Context);
  const { email, firstName, lastName } = useUserState();

  const handleClickItem = (id: string) => {
    if (id === "help") {
      window.open("https://intercom.help/gartner-buysmart-help-center", "_blank", "noreferrer");
    } else if (id === "notifications") {
      setIsNotificationsPanelOpen((prev) => !prev);
    } else if (id === "appTitle") {
      navigateToUrl("/s/home");
    }
  };

  const handleClickSignout = async () => {
    const res = await window.fetch(`${window.gxApiConnection}/api/v3/auth/logout`, { credentials: "include", method: "GET" });
    if (!res.ok) {
      return;
    }
    if (window.Intercom) {
      window.Intercom("shutdown");
    }
    sessionStorage.clear();
    localStorage.removeItem("genie_uid");
    window.eventBus.publish("USER_STATE_CLEAR");
    window.eventBus.publish("USER_LOGGED_OUT");
    window.eventBus.publish("WS_DISCONNECT");
    navigateToUrl("/login?logout=true");
  };

  return (
    <div className={styles.globalHeader}>
      <Header
        appLauncherProps={{
          environment: window.toolsEnv || "dev",
          preloadModules: true,
          preloadTimeout: 1500,
        }}
        appName={t("BuySmart")}
        isMenuOpen={isMobilePrimaryNavOpen}
        onItemClick={(_event, id) => handleClickItem(id)}
        onMenuClick={(isOpen) => setIsMobilePrimaryNavOpen(isOpen)}
        notificationCount={notificationCount}
        showAppLauncher={true}
        showHelp={true}
        showNotifications={true}
        userMenuListOptions={[
          { label:  t("Sign Out") , id: "sign-out", onClick: handleClickSignout },
        ]}
        userFirstName={firstName}
        userLastName={lastName}
        userEmail={email}
      />
    </div>
  );
};

export default GlobalHeaderComponent;
